// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%275%27 viewBox=%270 0 8 4%27%3E%3Cpath d=%27M4 4L0.535899 0.25L7.4641 0.25L4 4Z%27 fill=%27%23102C98%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdditionalCostList {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  overflow: auto;
}
.AdditionalCostList .Header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1.25rem;
}
.AdditionalCostList .Header .FilterContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 0.75rem;
}
.AdditionalCostList .Header .FilterContainer select {
  padding: 0.375rem 0.5rem 0.375rem 0.5rem;
  min-width: 7.5rem;
  background: var(--Foreground);
  color: var(--TextColor);
  border: none;
  border-radius: 0.25rem;
  font-size: 0.875rem;
}
.AdditionalCostList .Header .FilterContainer .Filter {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.375rem 0.5rem 0.375rem 0.5rem;
  background: #ffffff;
  border-radius: 0.25rem;
  cursor: pointer;
}
.AdditionalCostList .Header .FilterContainer .Filter svg {
  min-width: 1rem;
  min-height: 1rem;
}
.AdditionalCostList .Header .FilterContainer .Filter span {
  font-size: 0.875rem;
  line-height: 1rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.AdditionalCostList .AdditionalCostCont {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  overflow: auto;
  position: relative;
}
.AdditionalCostList .AdditionalCostCont .AdditionalCost {
  padding: 0.75rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  background: var(--Foreground);
  border-radius: 0.5rem;
}
.AdditionalCostList .AdditionalCostCont .AdditionalCost span {
  color: var(--TextColor);
  font-size: 0.75rem;
}
.AdditionalCostList .AdditionalCostCont .AdditionalCost .Name {
  width: 12rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
}
.AdditionalCostList .AdditionalCostCont .AdditionalCost section {
  flex: 1 1;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(10rem, 1fr));
  gap: 1rem;
}
.AdditionalCostList .AdditionalCostCont .AdditionalCost section .LabelValue {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
.AdditionalCostList .AdditionalCostCont .AdditionalCost section .LabelValue span {
  color: #9b9b9b;
  font-size: 500;
  font-size: 0.675rem;
}
.AdditionalCostList .AdditionalCostCont .AdditionalCost section .LabelValue span:nth-child(2) {
  font-size: 0.75rem;
  color: var(--TextColor);
}
.AdditionalCostList .AdditionalCostCont .AdditionalCost .Status {
  width: 6rem;
  height: 2rem;
  border-radius: 0.375rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: 500;
}
.AdditionalCostList .AdditionalCostCont .AdditionalCost .approved {
  background: var(--Completed);
}
.AdditionalCostList .AdditionalCostCont .AdditionalCost .rejected {
  background: var(--Cancelled);
}
.AdditionalCostList .AdditionalCostCont .AdditionalCost .waiting {
  background: var(--Invitation);
  transition: transform 0.3s ease;
}
.AdditionalCostList .AdditionalCostCont .AdditionalCost:hover .waiting {
  transform: scale(1.1);
  transition: transform 0.3s ease;
}
.AdditionalCostList .PaginationContainer {
  height: 3rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.AdditionalCostList .PaginationContainer .Pagination {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100%;
  gap: 0.25rem;
  padding-right: 1.25rem;
}
.AdditionalCostList .PaginationContainer .Pagination .NextPrev {
  color: #363854;
  background: none;
  border: none;
  font-size: 0.75rem;
  font-weight: 700;
  padding: 0.25rem 0.625rem;
}
.AdditionalCostList .PaginationContainer .Pagination .NextPrev:hover {
  border-radius: 1.5rem;
  background: #efefef;
}
.AdditionalCostList .PaginationContainer .Pagination .PageNo {
  width: 1.5rem;
  height: 1.5rem;
  color: #363854;
  border-radius: 1.25rem;
  padding: 0.25rem;
  background: none;
  border: none;
  font-size: 0.75rem;
  font-weight: 700;
}
.AdditionalCostList .PaginationContainer .Pagination .PageNo:hover {
  background: #efefef;
}
.AdditionalCostList .PaginationContainer .Pagination .CurrentPage {
  background: #efefef;
}
.AdditionalCostList .PaginationContainer .Pagination .disabled {
  color: #8a8a8a;
  cursor: not-allowed;
}
.AdditionalCostList .PaginationContainer .ItemsPerPage {
  width: 6.25rem;
  height: 1.875rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  border: 0.0625rem solid #102C98;
  border-radius: 0.5rem;
  padding-right: 0.25rem;
}
.AdditionalCostList .PaginationContainer .ItemsPerPage .OptionsLabel {
  color: #363854;
  font-size: 0.75rem;
  font-weight: 500;
  padding: 0 0.625rem;
  border-right: 0.0625rem solid #102C98;
}
.AdditionalCostList .PaginationContainer .ItemsPerPage .Options {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat right center;
  background-size: 0.875rem;
  width: 2.75rem;
  height: 1.25rem;
  border: none;
  font-size: 0.75rem;
  color: #363854;
  outline: none;
}
.AdditionalCostList .PaginationContainer .ItemsPerPage .Options option {
  background-color: #FFF;
  color: #363854;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/Components/AdditionalCost/AdditionalCostList.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,cAAA;AACF;AAAE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;AAEJ;AADI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;AAGN;AAFM;EACE,wCAAA;EACA,iBAAA;EACA,6BAAA;EACA,uBAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;AAIR;AAFM;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,wCAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;AAIR;AAHQ;EACE,eAAA;EACA,gBAAA;AAKV;AAHQ;EACE,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAKV;AAAE;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;AAEJ;AADI;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,6BAAA;EACA,qBAAA;AAGN;AAFM;EACE,uBAAA;EACA,kBAAA;AAIR;AAFM;EACE,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AAIR;AAFM;EACE,SAAA;EACA,aAAA;EACA,2DAAA;EACA,SAAA;AAIR;AAHQ;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAKV;AAJU;EACE,cAAA;EACA,cAAA;EACA,mBAAA;AAMZ;AAJU;EACE,kBAAA;EACA,uBAAA;AAMZ;AAFM;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AAIR;AAFM;EACE,4BAAA;AAIR;AAFM;EACE,4BAAA;AAIR;AAFM;EACE,6BAAA;EACA,+BAAA;AAIR;AADQ;EACE,qBAAA;EACA,+BAAA;AAGV;AAEE;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AAAJ;AACI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;AACN;AAAM;EACE,cAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;AAER;AAAM;EACE,qBAAA;EACA,mBAAA;AAER;AAAM;EACE,aAAA;EACA,cAAA;EACA,cAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AAER;AAAM;EACE,mBAAA;AAER;AAAM;EACE,mBAAA;AAER;AAAM;EACE,cAAA;EACA,mBAAA;AAER;AACI;EACE,cAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,+BAAA;EACA,qBAAA;EACA,sBAAA;AACN;AAAM;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qCAAA;AAER;AAAM;EACE,gBAAA;EACA,wBAAA;EACA,qBAAA;EACA,0EAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;AAER;AADQ;EACE,sBAAA;EACA,cAAA;EACA,kBAAA;AAGV","sourcesContent":[".AdditionalCostList{\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  overflow: auto;\n  .Header{\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 1.25rem;\n    .FilterContainer{\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      justify-content: flex-end;\n      gap: 0.75rem;\n      select{\n        padding: 0.375rem 0.5rem 0.375rem 0.5rem;\n        min-width: 7.5rem;\n        background: var(--Foreground);\n        color: var(--TextColor);\n        border: none;\n        border-radius: 0.25rem;\n        font-size: 0.875rem;\n      }\n      .Filter{\n        display: flex;\n        align-items: center;\n        gap: 0.5rem;\n        padding: 0.375rem 0.5rem 0.375rem 0.5rem;\n        background: #ffffff;\n        border-radius: 0.25rem;\n        cursor: pointer;\n        svg{\n          min-width: 1rem;\n          min-height: 1rem;\n        }\n        span{\n          font-size: 0.875rem;\n          line-height: 1rem;\n          white-space: nowrap;\n          overflow: hidden;\n          text-overflow: ellipsis;\n        }\n      }\n    }\n  }\n  .AdditionalCostCont{\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    overflow: auto;\n    position: relative;\n    .AdditionalCost{\n      padding: 0.75rem;\n      display: flex;\n      align-items: center;\n      gap: 1rem;\n      background: var(--Foreground);\n      border-radius: 0.5rem;\n      span{\n        color: var(--TextColor);\n        font-size: 0.75rem;\n      }\n      .Name{\n        width: 12rem;\n        font-size: 0.875rem;\n        font-weight: 500;\n        cursor: pointer;\n      }\n      section{\n        flex: 1;\n        display: grid;\n        grid-template-columns: repeat(auto-fit, minmax(10rem, 1fr));\n        gap: 1rem;\n        .LabelValue{\n          display: flex;\n          flex-direction: column;\n          gap: 0.25rem;\n          span{\n            color: #9b9b9b;\n            font-size: 500;\n            font-size: 0.675rem;\n          }\n          span:nth-child(2){\n            font-size: 0.75rem;\n            color: var(--TextColor);\n          }\n        }\n      }\n      .Status{\n        width: 6rem;\n        height: 2rem;\n        border-radius: 0.375rem;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 0.75rem;\n        font-weight: 500;\n      }\n      .approved {\n        background: var(--Completed);\n      }\n      .rejected{\n        background: var(--Cancelled);\n      }\n      .waiting{\n        background: var(--Invitation);\n        transition: transform 0.3s ease;\n      }\n      &:hover{\n        .waiting{\n          transform: scale(1.1);\n          transition: transform 0.3s ease;\n        }\n      }\n    }\n  }\n  .PaginationContainer{\n    height: 3rem;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    .Pagination{\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      height: 100%;\n      gap: 0.25rem;\n      padding-right: 1.25rem;\n      .NextPrev{\n        color: #363854;\n        background: none;\n        border: none;\n        font-size: 0.75rem;\n        font-weight: 700;\n        padding: 0.25rem 0.625rem;\n      }\n      .NextPrev:hover{\n        border-radius: 1.5rem;\n        background: #efefef;\n      }\n      .PageNo{\n        width: 1.5rem;\n        height: 1.5rem;\n        color: #363854;\n        border-radius: 1.25rem;\n        padding: 0.25rem;\n        background: none;\n        border: none;\n        font-size: 0.75rem;\n        font-weight: 700;\n      }\n      .PageNo:hover{\n        background: #efefef;\n      }\n      .CurrentPage{\n        background: #efefef;\n      }\n      .disabled{\n        color: #8a8a8a;\n        cursor: not-allowed;\n      }\n    }\n    .ItemsPerPage{\n      width: 6.25rem;\n      height: 1.875rem;\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      border: 0.0625rem solid #102C98;\n      border-radius: 0.5rem;\n      padding-right: 0.25rem;\n      .OptionsLabel{\n        color: #363854;\n        font-size: 0.75rem;\n        font-weight: 500;\n        padding: 0 0.625rem;\n        border-right: 0.0625rem solid #102C98;\n      }\n      .Options{\n        appearance: none;\n        -webkit-appearance: none;\n        -moz-appearance: none;\n        background: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='5' viewBox='0 0 8 4'%3E%3Cpath d='M4 4L0.535899 0.25L7.4641 0.25L4 4Z' fill='%23102C98'/%3E%3C/svg%3E\") no-repeat right center;\n        background-size: 0.875rem;\n        width: 2.75rem;\n        height: 1.25rem;\n        border: none;\n        font-size: 0.75rem;\n        color: #363854;\n        outline: none;\n        option{\n          background-color: #FFF;\n          color: #363854;\n          text-align: center;\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
